export default __webpack_public_path__ + "static/media/5.da96c1f1.jpg";